export const AVATAR_FALLBACK_COLORS = [
  '#0f766e', // teal
  '#1d4ed8', // blue
  '#4338ca', // indigo
  '#6d28d9', // violet
  '#a21caf', // fuchsia
  '#be185d', // pink
  '#b91c1c', // red
  '#c2410c', // orange
  '#a16207', // amber
  '#15803d', // green
  '#0e7490', // cyan
  '#334155', // slate
] as const;

export function getInitials(label: string | null | undefined): string {
  const value = label?.trim();
  if (!value) return '?';

  const emailLocalPart = value.includes('@') ? value.split('@')[0] : value;
  const parts = emailLocalPart.split(/\s+/);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }

  return emailLocalPart.slice(0, 1).toUpperCase();
}

export function getAvatarColor(seed: string | null | undefined): string {
  const value = seed?.trim() || 'default-avatar';
  let hash = 0;

  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }

  return AVATAR_FALLBACK_COLORS[Math.abs(hash) % AVATAR_FALLBACK_COLORS.length];
}
